// import "@mdi/font/css/materialdesignicons.css";
import Vue from "vue";
// import Vuetify from "vuetify";
import Vuetify, {
  VChip,
  VBtn,
  VIcon,
  VAvatar,
  VCard,
  VCheckbox,
  VDialog,
  VDivider,
  VImg,
  VMenu,
  VTextField,
  VTooltip,
  VTextarea,
  VList,
  VApp,
  VTabs,
  VTab,
} from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#2E8B57",
        secondary: "#595959",
        success: "#2b982b",
        warning: "#ff9600",
        danger: "#fb483a",
        bg_color_white: "#ffffff",
        bg_gray_1: "#646464",
      },
    },
  },
  VChip,
  VIcon,
  VBtn,
  VAvatar,
  VCard,
  VCheckbox,
  VDialog,
  VDivider,
  VImg,
  VMenu,
  VTextField,
  VTooltip,
  VTextarea,
  VList,
  VApp,
  VTabs,
  VTab,
});
